import { render, staticRenderFns } from "./CreateAccount_s5.vue?vue&type=template&id=077dd789"
import script from "./CreateAccount_s5.vue?vue&type=script&lang=js"
export * from "./CreateAccount_s5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports